import _Promise from '/var/www/html/node_modules/babel-runtime/core-js/promise';
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

var _4e71355a = function _4e71355a() {
	return import('../pages/unsubscribe.vue' /* webpackChunkName: "pages/unsubscribe" */).then(function (m) {
		return m.default || m;
	});
};
var _55964b46 = function _55964b46() {
	return import('../pages/subscription-check.vue' /* webpackChunkName: "pages/subscription-check" */).then(function (m) {
		return m.default || m;
	});
};
var _3dd52e12 = function _3dd52e12() {
	return import('../pages/_lang/index.vue' /* webpackChunkName: "pages/_lang/index" */).then(function (m) {
		return m.default || m;
	});
};
var _352e5c7a = function _352e5c7a() {
	return import('../pages/_lang/logout.vue' /* webpackChunkName: "pages/_lang/logout" */).then(function (m) {
		return m.default || m;
	});
};
var _8e13ad52 = function _8e13ad52() {
	return import('../pages/_lang/phone-search.vue' /* webpackChunkName: "pages/_lang/phone-search" */).then(function (m) {
		return m.default || m;
	});
};
var _07aa6114 = function _07aa6114() {
	return import('../pages/_lang/old-signup-2018-03-03.vue' /* webpackChunkName: "pages/_lang/old-signup-2018-03-03" */).then(function (m) {
		return m.default || m;
	});
};
var _4346ce6e = function _4346ce6e() {
	return import('../pages/_lang/reset-password.vue' /* webpackChunkName: "pages/_lang/reset-password" */).then(function (m) {
		return m.default || m;
	});
};
var _d5f8c9a8 = function _d5f8c9a8() {
	return import('../pages/_lang/no-result/index.vue' /* webpackChunkName: "pages/_lang/no-result/index" */).then(function (m) {
		return m.default || m;
	});
};
var _08e6aaec = function _08e6aaec() {
	return import('../pages/_lang/purchase-preview.vue' /* webpackChunkName: "pages/_lang/purchase-preview" */).then(function (m) {
		return m.default || m;
	});
};
var _a372b72a = function _a372b72a() {
	return import('../pages/_lang/successful-signup.vue' /* webpackChunkName: "pages/_lang/successful-signup" */).then(function (m) {
		return m.default || m;
	});
};
var _2ff18a20 = function _2ff18a20() {
	return import('../pages/_lang/directory/index.vue' /* webpackChunkName: "pages/_lang/directory/index" */).then(function (m) {
		return m.default || m;
	});
};
var _0e928860 = function _0e928860() {
	return import('../pages/_lang/contact.vue' /* webpackChunkName: "pages/_lang/contact" */).then(function (m) {
		return m.default || m;
	});
};
var _812f0604 = function _812f0604() {
	return import('../pages/_lang/pw3d-success.vue' /* webpackChunkName: "pages/_lang/pw3d-success" */).then(function (m) {
		return m.default || m;
	});
};
var _4046b4b4 = function _4046b4b4() {
	return import('../pages/_lang/t-auto-login.vue' /* webpackChunkName: "pages/_lang/t-auto-login" */).then(function (m) {
		return m.default || m;
	});
};
var _1360ad49 = function _1360ad49() {
	return import('../pages/_lang/payment/index.vue' /* webpackChunkName: "pages/_lang/payment/index" */).then(function (m) {
		return m.default || m;
	});
};
var _47b18ecf = function _47b18ecf() {
	return import('../pages/_lang/new-loading.vue' /* webpackChunkName: "pages/_lang/new-loading" */).then(function (m) {
		return m.default || m;
	});
};
var _34774108 = function _34774108() {
	return import('../pages/_lang/signup.vue' /* webpackChunkName: "pages/_lang/signup" */).then(function (m) {
		return m.default || m;
	});
};
var _cdd4548e = function _cdd4548e() {
	return import('../pages/_lang/flow---Mg==.vue' /* webpackChunkName: "pages/_lang/flow---Mg==" */).then(function (m) {
		return m.default || m;
	});
};
var _581c3c28 = function _581c3c28() {
	return import('../pages/_lang/aggregate-results.vue' /* webpackChunkName: "pages/_lang/aggregate-results" */).then(function (m) {
		return m.default || m;
	});
};
var _0d4cbe23 = function _0d4cbe23() {
	return import('../pages/_lang/flow---MQ==.vue' /* webpackChunkName: "pages/_lang/flow---MQ==" */).then(function (m) {
		return m.default || m;
	});
};
var _84da42d6 = function _84da42d6() {
	return import('../pages/_lang/pin-code.vue' /* webpackChunkName: "pages/_lang/pin-code" */).then(function (m) {
		return m.default || m;
	});
};
var _07b3db2e = function _07b3db2e() {
	return import('../pages/_lang/email-search.vue' /* webpackChunkName: "pages/_lang/email-search" */).then(function (m) {
		return m.default || m;
	});
};
var _2ca99770 = function _2ca99770() {
	return import('../pages/_lang/subscription-check.vue' /* webpackChunkName: "pages/_lang/subscription-check" */).then(function (m) {
		return m.default || m;
	});
};
var _79ce658a = function _79ce658a() {
	return import('../pages/_lang/forget-password.vue' /* webpackChunkName: "pages/_lang/forget-password" */).then(function (m) {
		return m.default || m;
	});
};
var _305a2772 = function _305a2772() {
	return import('../pages/_lang/terms.vue' /* webpackChunkName: "pages/_lang/terms" */).then(function (m) {
		return m.default || m;
	});
};
var _4105c696 = function _4105c696() {
	return import('../pages/_lang/set-password.vue' /* webpackChunkName: "pages/_lang/set-password" */).then(function (m) {
		return m.default || m;
	});
};
var _077cd129 = function _077cd129() {
	return import('../pages/_lang/login.vue' /* webpackChunkName: "pages/_lang/login" */).then(function (m) {
		return m.default || m;
	});
};
var _1e1d534d = function _1e1d534d() {
	return import('../pages/_lang/about.vue' /* webpackChunkName: "pages/_lang/about" */).then(function (m) {
		return m.default || m;
	});
};
var _268333aa = function _268333aa() {
	return import('../pages/_lang/optout.vue' /* webpackChunkName: "pages/_lang/optout" */).then(function (m) {
		return m.default || m;
	});
};
var _524ddf68 = function _524ddf68() {
	return import('../pages/_lang/login-by-phone.vue' /* webpackChunkName: "pages/_lang/login-by-phone" */).then(function (m) {
		return m.default || m;
	});
};
var _103fa124 = function _103fa124() {
	return import('../pages/_lang/member/profile.vue' /* webpackChunkName: "pages/_lang/member/profile" */).then(function (m) {
		return m.default || m;
	});
};
var _6aaac90e = function _6aaac90e() {
	return import('../pages/_lang/member/all-charges.vue' /* webpackChunkName: "pages/_lang/member/all-charges" */).then(function (m) {
		return m.default || m;
	});
};
var _5d0625ec = function _5d0625ec() {
	return import('../pages/_lang/download-app/successful-download-app.vue' /* webpackChunkName: "pages/_lang/download-app/successful-download-app" */).then(function (m) {
		return m.default || m;
	});
};
var _e0317c78 = function _e0317c78() {
	return import('../pages/_lang/member/search-history.vue' /* webpackChunkName: "pages/_lang/member/search-history" */).then(function (m) {
		return m.default || m;
	});
};
var _585a7f4e = function _585a7f4e() {
	return import('../pages/_lang/directory/email/_page.vue' /* webpackChunkName: "pages/_lang/directory/email/_page" */).then(function (m) {
		return m.default || m;
	});
};
var _664d13ab = function _664d13ab() {
	return import('../pages/_lang/directory/phone/_page.vue' /* webpackChunkName: "pages/_lang/directory/phone/_page" */).then(function (m) {
		return m.default || m;
	});
};
var _32852a28 = function _32852a28() {
	return import('../pages/_lang/payment/package/_id.vue' /* webpackChunkName: "pages/_lang/payment/package/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _c5d3d414 = function _c5d3d414() {
	return import('../pages/_lang/directory/people/_letter/_page.vue' /* webpackChunkName: "pages/_lang/directory/people/_letter/_page" */).then(function (m) {
		return m.default || m;
	});
};
var _738f3c66 = function _738f3c66() {
	return import('../pages/_lang/search-result/_id.vue' /* webpackChunkName: "pages/_lang/search-result/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _ac2e020c = function _ac2e020c() {
	return import('../pages/_lang/page/_slug.vue' /* webpackChunkName: "pages/_lang/page/_slug" */).then(function (m) {
		return m.default || m;
	});
};
var _24561b87 = function _24561b87() {
	return import('../pages/_lang/download-app/_slug.vue' /* webpackChunkName: "pages/_lang/download-app/_slug" */).then(function (m) {
		return m.default || m;
	});
};
var _89d673f0 = function _89d673f0() {
	return import('../pages/_lang/loginas/_login_token.vue' /* webpackChunkName: "pages/_lang/loginas/_login_token" */).then(function (m) {
		return m.default || m;
	});
};
var _3b8110b0 = function _3b8110b0() {
	return import('../pages/_lang/assistant/_id/_token.vue' /* webpackChunkName: "pages/_lang/assistant/_id/_token" */).then(function (m) {
		return m.default || m;
	});
};
var _133dfec6 = function _133dfec6() {
	return import('../pages/_lang/search-results/_type/_search/index.vue' /* webpackChunkName: "pages/_lang/search-results/_type/_search/index" */).then(function (m) {
		return m.default || m;
	});
};
var _1cc7cb30 = function _1cc7cb30() {
	return import('../pages/_lang/search-results/_type/_search/loading.vue' /* webpackChunkName: "pages/_lang/search-results/_type/_search/loading" */).then(function (m) {
		return m.default || m;
	});
};
var _6dc383ad = function _6dc383ad() {
	return import('../pages/_lang/directory/_country/_state/_city/_id/_page.vue' /* webpackChunkName: "pages/_lang/directory/_country/_state/_city/_id/_page" */).then(function (m) {
		return m.default || m;
	});
};
var _73c4be6c = function _73c4be6c() {
	return import('../pages/_lang/_search/index.vue' /* webpackChunkName: "pages/_lang/_search/index" */).then(function (m) {
		return m.default || m;
	});
};
var _40cd0313 = function _40cd0313() {
	return import('../pages/_lang/_search/p/_id.vue' /* webpackChunkName: "pages/_lang/_search/p/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _7f6ad252 = function _7f6ad252() {
	return import('../pages/_lang/_search/_country/index.vue' /* webpackChunkName: "pages/_lang/_search/_country/index" */).then(function (m) {
		return m.default || m;
	});
};
var _0bcb96ca = function _0bcb96ca() {
	return import('../pages/_lang/_search/_country/p/_id.vue' /* webpackChunkName: "pages/_lang/_search/_country/p/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _934d4976 = function _934d4976() {
	return import('../pages/_lang/_search/_country/_state/index.vue' /* webpackChunkName: "pages/_lang/_search/_country/_state/index" */).then(function (m) {
		return m.default || m;
	});
};
var _3108bd8e = function _3108bd8e() {
	return import('../pages/_lang/_search/_country/_state/p/_id.vue' /* webpackChunkName: "pages/_lang/_search/_country/_state/p/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _76464d80 = function _76464d80() {
	return import('../pages/_lang/_search/_country/_state/_city/index.vue' /* webpackChunkName: "pages/_lang/_search/_country/_state/_city/index" */).then(function (m) {
		return m.default || m;
	});
};
var _1e14a06e = function _1e14a06e() {
	return import('../pages/_lang/_search/_country/_state/_city/p/_id.vue' /* webpackChunkName: "pages/_lang/_search/_country/_state/_city/p/_id" */).then(function (m) {
		return m.default || m;
	});
};

if (process.client) {
	window.history.scrollRestoration = 'manual';
}
var scrollBehavior = function scrollBehavior(to, from, savedPosition) {
	// if the returned position is falsy or an empty object,
	// will retain current scroll position.
	var position = false;

	// if no children detected
	if (to.matched.length < 2) {
		// scroll to the top of the page
		position = { x: 0, y: 0 };
	} else if (to.matched.some(function (r) {
		return r.components.default.options.scrollToTop;
	})) {
		// if one of the children has scrollToTop option set to true
		position = { x: 0, y: 0 };
	}

	// savedPosition is only available for popstate navigations (back button)
	if (savedPosition) {
		position = savedPosition;
	}

	return new _Promise(function (resolve) {
		// wait for the out transition to complete (if necessary)
		window.$nuxt.$once('triggerScroll', function () {
			// coords will be used if no selector is provided,
			// or if the selector didn't match any element.
			if (to.hash) {
				var hash = to.hash;
				// CSS.escape() is not supported with IE and Edge.
				if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
					hash = '#' + window.CSS.escape(hash.substr(1));
				}
				try {
					if (document.querySelector(hash)) {
						// scroll to anchor by returning the selector
						position = { selector: hash };
					}
				} catch (e) {
					console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).');
				}
			}
			resolve(position);
		});
	});
};

export function createRouter() {
	return new Router({
		mode: 'history',
		base: '/',
		linkActiveClass: 'nuxt-link-active',
		linkExactActiveClass: 'nuxt-link-exact-active',
		scrollBehavior: scrollBehavior,
		routes: [{
			path: "/unsubscribe",
			component: _4e71355a,
			name: "unsubscribe"
		}, {
			path: "/subscription-check",
			component: _55964b46,
			name: "subscription-check"
		}, {
			path: "/:lang",
			component: _3dd52e12,
			name: "lang"
		}, {
			path: "/:lang/logout",
			component: _352e5c7a,
			name: "lang-logout"
		}, {
			path: "/:lang/phone-search",
			component: _8e13ad52,
			name: "lang-phone-search"
		}, {
			path: "/:lang/old-signup-2018-03-03",
			component: _07aa6114,
			name: "lang-old-signup-2018-03-03"
		}, {
			path: "/:lang/reset-password",
			component: _4346ce6e,
			name: "lang-reset-password"
		}, {
			path: "/:lang/no-result",
			component: _d5f8c9a8,
			name: "lang-no-result"
		}, {
			path: "/:lang/purchase-preview",
			component: _08e6aaec,
			name: "lang-purchase-preview"
		}, {
			path: "/:lang/successful-signup",
			component: _a372b72a,
			name: "lang-successful-signup"
		}, {
			path: "/:lang/directory",
			component: _2ff18a20,
			name: "lang-directory"
		}, {
			path: "/:lang/contact",
			component: _0e928860,
			name: "lang-contact"
		}, {
			path: "/:lang/pw3d-success",
			component: _812f0604,
			name: "lang-pw3d-success"
		}, {
			path: "/:lang/t-auto-login",
			component: _4046b4b4,
			name: "lang-t-auto-login"
		}, {
			path: "/:lang/payment",
			component: _1360ad49,
			name: "lang-payment"
		}, {
			path: "/:lang/new-loading",
			component: _47b18ecf,
			name: "lang-new-loading"
		}, {
			path: "/:lang/signup",
			component: _34774108,
			name: "lang-signup"
		}, {
			path: "/:lang/flow---Mg==",
			component: _cdd4548e,
			name: "lang-flow---Mg=="
		}, {
			path: "/:lang/aggregate-results",
			component: _581c3c28,
			name: "lang-aggregate-results"
		}, {
			path: "/:lang/flow---MQ==",
			component: _0d4cbe23,
			name: "lang-flow---MQ=="
		}, {
			path: "/:lang/pin-code",
			component: _84da42d6,
			name: "lang-pin-code"
		}, {
			path: "/:lang/email-search",
			component: _07b3db2e,
			name: "lang-email-search"
		}, {
			path: "/:lang/subscription-check",
			component: _2ca99770,
			name: "lang-subscription-check"
		}, {
			path: "/:lang/forget-password",
			component: _79ce658a,
			name: "lang-forget-password"
		}, {
			path: "/:lang/terms",
			component: _305a2772,
			name: "lang-terms"
		}, {
			path: "/:lang/set-password",
			component: _4105c696,
			name: "lang-set-password"
		}, {
			path: "/:lang/login",
			component: _077cd129,
			name: "lang-login"
		}, {
			path: "/:lang/about",
			component: _1e1d534d,
			name: "lang-about"
		}, {
			path: "/:lang/optout",
			component: _268333aa,
			name: "lang-optout"
		}, {
			path: "/:lang/login-by-phone",
			component: _524ddf68,
			name: "lang-login-by-phone"
		}, {
			path: "/:lang/member/profile",
			component: _103fa124,
			name: "lang-member-profile"
		}, {
			path: "/:lang/member/all-charges",
			component: _6aaac90e,
			name: "lang-member-all-charges"
		}, {
			path: "/:lang/download-app/successful-download-app",
			component: _5d0625ec,
			name: "lang-download-app-successful-download-app"
		}, {
			path: "/:lang/member/search-history",
			component: _e0317c78,
			name: "lang-member-search-history"
		}, {
			path: "/:lang/directory/email/:page?",
			component: _585a7f4e,
			name: "lang-directory-email-page"
		}, {
			path: "/:lang/directory/phone/:page?",
			component: _664d13ab,
			name: "lang-directory-phone-page"
		}, {
			path: "/:lang/payment/package/:id?",
			component: _32852a28,
			name: "lang-payment-package-id"
		}, {
			path: "/:lang/directory/people/:letter?/:page?",
			component: _c5d3d414,
			name: "lang-directory-people-letter-page"
		}, {
			path: "/:lang/search-result/:id",
			component: _738f3c66,
			name: "lang-search-result-id"
		}, {
			path: "/:lang/page/:slug?",
			component: _ac2e020c,
			name: "lang-page-slug"
		}, {
			path: "/:lang/download-app/:slug?",
			component: _24561b87,
			name: "lang-download-app-slug"
		}, {
			path: "/:lang/loginas/:login_token?",
			component: _89d673f0,
			name: "lang-loginas-login_token"
		}, {
			path: "/:lang/assistant/:id?/:token?",
			component: _3b8110b0,
			name: "lang-assistant-id-token"
		}, {
			path: "/:lang/search-results/:type/:search?",
			component: _133dfec6,
			name: "lang-search-results-type-search"
		}, {
			path: "/:lang/search-results/:type/:search?/loading",
			component: _1cc7cb30,
			name: "lang-search-results-type-search-loading"
		}, {
			path: "/:lang/directory/:country?/:state?/:city?/:id?/:page?",
			component: _6dc383ad,
			name: "lang-directory-country-state-city-id-page"
		}, {
			path: "/:lang/:search",
			component: _73c4be6c,
			name: "lang-search"
		}, {
			path: "/:lang/:search/p/:id?",
			component: _40cd0313,
			name: "lang-search-p-id"
		}, {
			path: "/:lang/:search/:country",
			component: _7f6ad252,
			name: "lang-search-country"
		}, {
			path: "/:lang/:search/:country/p/:id?",
			component: _0bcb96ca,
			name: "lang-search-country-p-id"
		}, {
			path: "/:lang/:search/:country/:state",
			component: _934d4976,
			name: "lang-search-country-state"
		}, {
			path: "/:lang/:search/:country/:state/p/:id?",
			component: _3108bd8e,
			name: "lang-search-country-state-p-id"
		}, {
			path: "/:lang/:search/:country/:state/:city",
			component: _76464d80,
			name: "lang-search-country-state-city"
		}, {
			path: "/:lang/:search/:country/:state/:city/p/:id?",
			component: _1e14a06e,
			name: "lang-search-country-state-city-p-id"
		}],

		fallback: false
	});
}


//////////////////
// WEBPACK FOOTER
// ./.nuxt/router.js
// module id = ./.nuxt/router.js
// module chunks = 54